module.exports = __webpack_public_path__ + "img/icon_confirm.cac5c002.png";